module.exports = __webpack_public_path__ + "img/ClickForSound_11.f7a068d5.png";